import SystemManager from "@/views/system/SystemManager"
import PeopleManager from "@/views/system/PeopleManager"
import RoleManager from "@/views/system/RoleManager"
import ClinicManager from "@/views/system/ClinicManager"
export const systemmanager = {
    path: '/systemmanager',
    name: 'SystemManager',
    component: SystemManager,
    children:[
      // clinicmanager,peoplemanager,rolemanager
      {
        path: '/clinicmmanager',
        name: 'ClinicManager',
        component: ClinicManager,
      },
      {
        path: '/rolemmanager',
        name: 'RoleManager',
        component: RoleManager,
      },
      {
        path: '/peoplemmanager',
        name: 'PeopleManager',
        component: PeopleManager,
      },
    ]
  }


// WEBPACK FOOTER //
// ./src/router/index/system/index.js